module.exports = __webpack_public_path__ + "assets1779866876160/img/unified-avator.51eaf086.png";